import pl from "@locales/common/pl.json";
import en from "@locales/common/en.json";

export default {
  pl: pl,
  en: en,
};
